
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/center/[name]",
      function () {
        return require("private-next-pages/center/[name].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/center/[name]"])
      });
    }
  